<template>
  <div class="edit-bg">
    <div class="edit-container">
      <button class="back-btn" @click="goBack">← 返回</button>
      <h2>{{ isEdit ? '编辑龟谷笔记' : '发布龟谷笔记' }}</h2>
      <div class="form-row">
        <label>标题：</label>
        <input
          class="input"
          v-model="hgArticles.title"
          placeholder="请输入标题"
        >
      </div>
      <div class="form-row">
        <label>内容：</label>
        <div class="editor-wrapper">
          <Toolbar
            :editor="editorRef"
            :default-config="toolbarConfig"
            style="border-bottom: 1px solid #ccc"
          />
          <Editor
            v-model="hgArticles.content"
            :default-config="editorConfig"
            style="min-height: 300px; width: 100%; background: #fff;"
            mode="default"
            @on-created="handleCreated"
            @on-change="handleChange"
          />
        </div>
      </div>
      <div class="form-row">
        <label class="checkbox">
          <input
            type="checkbox"
            v-model="showStatusChecked"
          >
          公开到龟谷圈
        </label>
      </div>
      <div class="form-row">
        <button class="save-btn" @click="saveNote">保存</button>
      </div>
      <div v-if="showMsg" class="msg">保存成功！</div>
    </div>
  </div>
</template>

<script setup>
import { ref, shallowRef, onBeforeUnmount, computed } from 'vue'
import { uploadImage } from '@/api/uploadImage'
import { insetArticle } from '@/api/articles'
import '@wangeditor/editor/dist/css/style.css'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { useRouter } from 'vue-router'
const router = useRouter()
import { ElMessage } from 'element-plus'
// 编辑器实例，必须用 shallowRef
const editorRef = shallowRef()

// 内容 HTML
const isEdit = ref(false)
const showMsg = ref(false)
// 格式化日期函数（可复用）
function formatDate(date) {
  const YYYY = date.getFullYear()
  const MM = String(date.getMonth() + 1).padStart(2, '0')
  const dd = String(date.getDate()).padStart(2, '0')
  const HH = String(date.getHours()).padStart(2, '0')
  const mm = String(date.getMinutes()).padStart(2, '0')
  const ss = String(date.getSeconds()).padStart(2, '0')
  return `${YYYY}-${MM}-${dd} ${HH}:${mm}:${ss}`
}
const hgArticles = ref({
  title: '',
  content: '',
  flag:'1',
  picture:'',
  createdDate: formatDate(new Date()),
  showStatus: 1
})

// 计算属性：将数字转换为布尔值用于复选框
const showStatusChecked = computed({
  get: () => hgArticles.value.showStatus === 1,
  set: (value) => {
    hgArticles.value.showStatus = value ? 1 : 0
  }
})

// 工具栏配置
const toolbarConfig = {
  excludeKeys: [
    'uploadVideo',
    'insertTable',
    'codeBlock',
    'fullScreen',
    // 禁用网络图片插入，仅保留本地上传
    'insertImage'
  ]
}

// 编辑器配置
const editorConfig = {
  placeholder: '请输入内容...',
  autoFocus: false, // 禁用自动聚焦
  MENU_CONF: {
    uploadImage: {
      // 使用自定义上传函数：上传到腾讯云 COS
      async customUpload(file, insertFn) {
        try {
          console.log('开始上传图片到后台:', file?.name)
          const formData = new FormData()
          formData.append('file', file)
          const res = await uploadImage(formData)
          const url = res?.url || res?.data?.url || res?.data
          if (url) {
            hgArticles.value.picture = url
            insertFn(url, file?.name || 'image')
          } else {
            alert('图片上传失败：未获取到返回 URL')
          }
        } catch (err) {
          console.error('图片上传失败(后端):', err)
          alert('图片上传失败，请重试')
        }
      },
      maxFileSize: 5 * 1024 * 1024, // 5MB
      maxNumberOfFiles: 10,
      allowedFileTypes: ['image/*']
    }
  }
}

// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
  const editor = editorRef.value
  if (editor == null) return
  editor.destroy()
})

// 编辑器创建完成时的回调
const handleCreated = (editor) => {
  editorRef.value = editor
  
  // 设置初始文本对齐方式为左对齐
  setTimeout(() => {
    const textContainer = editor.getEditableContainer()
    if (textContainer) {
      textContainer.style.textAlign = 'left'
    }
  }, 100)
}

// 编辑器内容变化时的回调
const handleChange = (editor) => {
  hgArticles.value.content = editor.getHtml()
}

// 保存笔记
const saveNote = async  () => {
  if (! hgArticles.value.title.trim()) {
    alert('请输入标题')
    return
  }
  
  if (!hgArticles.value.content.trim()) {
    alert('请输入内容')
    return
  }
  
  // 这里可以发送到后端
  console.log('标题:', hgArticles.value.title)
  console.log('内容HTML:', hgArticles.value.content)
  console.log('是否公开:', hgArticles.value.isOpen)
  const res = await insetArticle(JSON.stringify(hgArticles.value))
  
    if(res.code == 200){

     ElMessage.success('保存成功');  
    }else{  
      ElMessage.success('保存失败');  
    }
    
    router.push('/hall')
}
const goBack = () => {
  router.back()
}
</script>

<style scoped>
.edit-bg {
  min-height: 100vh;
  background: #f6fbff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.edit-container {
  background: #fff;
  position: relative;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.06);
  padding: 38px 36px 28px 36px;
  min-width: 340px;
  max-width: 800px;
  width: 100%;
}
.back-btn {
  position: absolute;
  left: 32px;
  top: 24px;
  background: none;
  border: none;
  color: #258aff;
  font-size: 16px;
  cursor: pointer;
  font-weight: 600;
  padding: 0;
  transition: color 0.2s;
}
.back-btn:hover {
  color: #00b8d9;
}

h2 {
  text-align: center;
  color: #258aff;
  margin-bottom: 28px;
}

.form-row {
  margin-bottom: 18px;
  display: flex;
  align-items: flex-start;
}

label {
  min-width: 54px;
  color: #333;
  font-size: 15px;
  margin-top: 8px;
}

.input {
  flex: 1;
  padding: 8px 10px;
  border: 1.2px solid #e6e6e6;
  border-radius: 6px;
  font-size: 15px;
  outline: none;
  margin-left: 8px;
}

.editor-wrapper {
  flex: 1;
  margin-left: 8px;
  border: 1.2px solid #e6e6e6;
  border-radius: 6px;
  overflow: hidden;
}

.save-btn {
  background: #258aff;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px 0;
  font-size: 16px;
  font-weight: 600;
  width: 100%;
  cursor: pointer;
  margin-left: 54px;
  transition: background-color 0.3s;
}

.save-btn:hover {
  background: #1a6fd9;
}

.msg {
  text-align: center;
  color: #258aff;
  margin-top: 18px;
  font-weight: 500;
}

.checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.checkbox input[type="checkbox"] {
  margin: 0;
  cursor: pointer;
}

/* 编辑器样式调整 */
:deep(.w-e-text-container) {
  background-color: #fff !important;
}

:deep(.w-e-toolbar) {
  background-color: #fafafa !important;
  border-bottom: 1px solid #e6e6e6 !important;
}

:deep(.w-e-bar-item) {
  color: #333 !important;
}

:deep(.w-e-bar-item:hover) {
  background-color: #e6f3ff !important;
}

/* 修复光标居中问题 */
:deep(.w-e-text) {
  text-align: left !important;
}

:deep(.w-e-text p) {
  text-align: left !important;
}

:deep(.w-e-text-container [data-slate-editor]) {
  text-align: left !important;
}

/* 确保编辑器内容左对齐 */
:deep(.w-e-text-container .w-e-text) {
  text-align: left !important;
  display: block !important;
}
</style> 